import type { IAiSearchResponse } from './client';

/**
 * Flattens an AI-search extraction into queryable event attributes for the
 * 'AI Search Submitted' event. Kept flat (scalars + comma-joined lists, no
 * nested objects) because trackEvent fans out to GTM, which stringifies nested
 * values. Undefined entries are dropped downstream (compact), so we only emit a
 * key when the renter actually expressed that facet.
 *
 * `filter_keys` captures WHICH facets were set regardless of type — the single
 * most useful attribute for "what are people searching by".
 */
export function aiSearchFilterAttributes(resp: IAiSearchResponse): Record<string, unknown> {
  const f = resp.filters;
  const list = (v?: string[]) => (v && v.length ? v.join(',') : undefined);

  return {
    intent: resp.intent,
    filters_count: Object.keys(f).length,
    filter_keys: list(Object.keys(f)),
    removed: list(resp.remove),

    has_location: Boolean(f.address),
    has_dates: Boolean(f.dateFrom && f.dateTo),
    vehicle_types: list(f.vehicleType),
    style: f.style,
    price_min: f.priceMin,
    price_max: f.priceMax,
    length_max: f.lengthMax,
    sleeps_adults: f.sleepsAdults,
    sleeps_children: f.sleepsChildren,
    seatbelts: f.seatbelts,
    features: list(f.features),
    pet_friendly: f.petFriendly || undefined,
    delivery: f.delivery || undefined,
    delivery_stationary: f.deliveryStationary || undefined,
    instant_book: f.instantBook || undefined,
    unlimited_miles: f.unlimitedMiles || undefined,
    unlimited_generator: f.unlimitedGenerator || undefined,
    makes: list(f.make),
    models: list(f.model),
    host_types: list(f.hostType),
    flexible_cancellation: f.flexibleCancellation || undefined,
    min_rating: f.minRating,
    nearby: f.nearby || undefined,
    keywords: f.keywords,
  };
}
